import type { FC } from 'react';
import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import type { DashboardWidgetProps } from 'src/types/dashboard';
import useGuidedTour from 'src/components/app/context/GuidedTourContext';

import { styles } from './index.styles';

const TextWidget: FC<DashboardWidgetProps> = ({ config }) => {
  const { widget_text } = config;
  const { createStep } = useGuidedTour();
  const guidedTour = useMemo(
    () => createStep(config.id, config.guided_tour_step),
    [config.guided_tour_step],
  );

  return (
    <Box
      className="TextWidget-root"
      data-test-id="TextWidgetRoot"
      sx={styles.textWidget}
    >
      {!!guidedTour && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        >
          {guidedTour}
        </Box>
      )}
      <Typography sx={styles.text}>{widget_text}</Typography>
    </Box>
  );
};

export default TextWidget;
